'use strict'

import '@babel/polyfill'
require("picturefill")
import 'objectFitPolyfill'
import 'custom-event-polyfill'
import Stickyfill from 'stickyfilljs'
import 'nodelist-foreach-polyfill'
import 'url-polyfill'
// import 'scroll-behavior-polyfill'


import Intersection from './Intersection.js'


function load_init() {
  var  $win          = $(window)
  ,winH          = $win.height()
  ,current_pos   = $win.scrollTop()
  ,$scroll_in = $(".scroll-in")
  ,$util = $(".sdgs-util")
  ,$rnav_pos = $(".sec-introduction")
  //スクロールアニメ
  function scrollIn(){
    $scroll_in.not(".is-show").each(function(){
        var $this = $(this)
        var elemPos = $this.offset().top
        if(current_pos > elemPos - winH + 150){
            $this.addClass("is-show")
        }
    })

    //ヘッダ追従
    if(current_pos > $rnav_pos.offset().top){
      $util.addClass("is-active")
    }else {
      $util.removeClass("is-active")
    }

  }
  scrollIn()
  
  addEventListener('scroll', function(){
    current_pos = $win.scrollTop()
    scrollIn()
  }, { passive: true })
}

$(window).on('load',function(){
  load_init()
})

$(() => {

  // load  ------------------------------------------------
  const $content = $('.sdgs-content')
  $content.addClass('ready')

  // menu layer
  $('.js_toggle-menu').on('click', e => {
    $content.toggleClass('is_menu-active')
  })
  $('.js_menu-item').on('click', e => {
    $content.removeClass('is_menu-active')
  })


  // in view effect 
  const intersections = new Intersection('.inview', entries => {
    entries.forEach((entry, t, b) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-inview')
      }
    })
  }, {
    rootMargin: "0px 0px -15% 0px",
    threshold: 0
  })

  const stickeyGallery = document.querySelectorAll('.js-sticky-intersection')
  stickeyGallery.forEach( el => {
    const stickyGalleryWrapper = el.querySelector('.js-intersection-gallery--target')
    const galleryTarget = el.querySelectorAll('.js-intersection-gallery')
    const stickyGallery = new Intersection(galleryTarget, entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const current = entry.target.getAttribute('data-intersection')
          stickyGalleryWrapper.setAttribute('data-current', current)
        }
      })
    }, {
      root: null,
      rootMargin: "0px",
      threshold: 0
    })
  })



  //シェアボタンの制御
  $(".js-share").each(function () {
    const $this = $(this)
    const title = $this.attr('data-share-text')
    const tags = $this.data('share-tags')
    const path = encodeURI($this.attr("data-url"))

    //facebook
    $(".js-share-facebook", $this).on('click', ()  => {
      const url = "http://www.facebook.com/share.php?u=" + path
      window.open(url, 'facebook', 'width=500, height=500, menubar=no, toolbar=no, scrollbars=yes')
    })

    //twitter
    $(".js-share-twitter", $this).on('click', ()  => {
      const url = "https://twitter.com/intent/tweet?text=" + encodeURI(title) + "&url=" + path + "&hashtags=" + tags.join(',')
      window.open(url, 'twitter', 'width=500, height=500, menubar=no, toolbar=no, scrollbars=yes')
    })

    //line
    $(".js-share-line", $this).on('click', ()  => {
      const url = "http://line.me/R/msg/text/?" + path
      window.open(url, 'line', 'width=500, height=500, menubar=no, toolbar=no, scrollbars=yes')
    })
  })



  const tag = document.createElement('script')
  tag.src = "https://www.youtube.com/iframe_api"
  const firstScriptTag = document.getElementsByTagName('script')[0]
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)


  // YouTube ------------------------------------------------------------
  let videoShowStatus = false
  let videoPauseStatus = false
  const ytPlayerContainer = new Intersection('.js-youtube-player', entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if(!videoPauseStatus) {
          player.playVideo()
        }
        videoShowStatus = true
      } else {
        videoShowStatus = false
        player.pauseVideo()
      }
    })
  }, {
    root: null,
    autoInit: false,
    rootMargin: "0px 0px 0px 0px",
    threshold: 0
  })

  let player
  const videoId = document.getElementById('section01__video').getAttribute('data-ytid')
  window.onYouTubeIframeAPIReady = () => {
    player = new YT.Player('section01__video', {
      height: '360',
      width: '640',
      videoId: videoId,
      playerVars: {
        'showinfo': 0,
      },
      events: {
        'onReady': e => {
          e.target.mute()
          ytPlayerContainer.init()
        },
        'onStateChange': e => {
          if (videoShowStatus && e.data === YT.PlayerState.PAUSED) {
            videoPauseStatus = 1
          }
          if (e.data === YT.PlayerState.PLAYING) {
            videoPauseStatus = 0
          }
        }
      }
    })
  }

  // smooth scroll ------------------------------------------------------------
  function scrollTo(top){
    $('html,body').animate({ scrollTop: top }, {'easing': 'swing', 'duration': 500})
  }
  function calcScrollTo($el){
    const offset = 0;
    if($el.length){
      var to = $el.offset().top
    }else{
      var to = 0;
    }
    return to - offset;
  }
  $('a[href ^= "#"]').on('click', function(e){
    const $this = $(this);
    const id = $this.attr('href');
    if(id === '#') return false;
    const $el = $(id);
    scrollTo(calcScrollTo($el));

    if($this.hasClass('nohash')){
      e.preventDefault();
    }
    e.stopPropagation();
  })

  // polyfill
  const elements = $('.js-sticky')
  Stickyfill.add(elements)

  objectFitPolyfill()


})
